import { useComputedColorScheme } from "@mantine/core";

/**
 * The color scheme that is shown: "light" or "dark", with "auto" resolved to the system's. Use it for styling.
 * `useMantineColorScheme().colorScheme` is the setting, which is "auto" when the app follows the system,
 * so comparing it to "dark" gives light colors on a dark system.
 * Read right away (not after the first render), so components don't flash in light colors when they appear.
 */
export const useShownColorScheme = () =>
  useComputedColorScheme("light", { getInitialValueInEffect: false });
